import clsx from 'clsx';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { createUseStyles, useTheme } from 'react-jss';
import { SelectionContext } from '../contexts/SelectionContext';
import { PhoneIcon, SuitcaseIcon } from './KioskIcons';
import { KioskQrCode } from './KioskQrCode';

const useStyles = createUseStyles((theme: any) => ({
  bgNeutral: {
    background: theme.palette.neutral[200],
  },
  bgPrimary: {
    background: theme.palette.primary[400],
    color: theme.palette.contrastText,
  },
  border: {
    border: `1px solid ${theme.palette.neutral[200]}`,
  },
}));

export const KioskQrCodeCard = () => {
  const classes = useStyles({ theme: useTheme() });
  const [{ service }] = useContext(SelectionContext);

  return (
    <section
      className={clsx(
        'flex gap-5 p-5 max-w-full items-center m-5 mb-0 rounded',
        classes.border,
      )}
    >
      <div className="w-full flex gap-6 flex-grow flex-col justify-between">
        <div className="flex gap-3 items-center">
          <PhoneIcon />
          <div className="flex flex-col gap-1.5 mt-0.5">
            <span className="font-medium">
              <FormattedMessage id="DetailsForm.qr.title" />
            </span>
            <div className="text-black-60 flex gap-2 items-center">
              <SuitcaseIcon />
              <span>{service.name}</span>
            </div>
          </div>
        </div>
        <p className="leading-5">
          <FormattedMessage id="DetailsForm.qr.description" />
        </p>
      </div>
      <div
        className={clsx(
          'w-px self-stretch flex-shrink-0 rounded-full',
          classes.bgNeutral,
        )}
      />
      <div className="w-28 flex flex-col flex-shrink-0">
        <KioskQrCode />
        <span className="text-center text-sm pt-1 rounded">
          <FormattedMessage id="Landing.kiosk.qr_code.scan" />
        </span>
      </div>
    </section>
  );
};
